import { FormSubmitData, FormSubmitParameters } from './form.types';

export const handleFormSubmit = <Values>(
  fn: (data: FormSubmitData<Values>) => Promise<unknown>,
) => (...data: FormSubmitParameters<Values>) =>
  fn({ values: data[0], helpers: data[1] });
